<template>
     <div class="box">
        <div class="contaner-title"><span>项目管理</span> <span>/ 竞标项目</span> <span>/ 管理项目</span></div>
        <div class="hr"></div>
        <div class="box-contaner">
            <div class="box-top" >
             <Row class="box-top-title">
                    <Col span="20"><p class="title">{{ProjectDetail.Name}}   <Button type="error" size="small" ghost>剩余{{ProjectDetail.DayNum}}天</Button></p></Col>
                    <Col span="4"><span>发布时间 : {{ProjectDetail.AddTime}}</span></Col>
                </Row>
            <Row class="box-top-center">
                    <Col span="2">预算 <span>{{ProjectDetail.Budget}}元</span></Col>
                    <Col span="3">类型 <span>{{ProjectDetail.ClassName}}</span></Col>
                    <Col span="1">&nbsp;</Col>
                    <Col span="14">周期 <span>{{ProjectDetail.PlanningTime}}天</span></Col>
                    <Col span="4">
                        <Button v-if="UserType == 1" type="primary" size="small" @click="editBiddingProject">{{biddingProjectTxt}}</Button>
                        <Button v-if="UserType == 2 || UserType == 3" type="primary" size="small" @click="editProject">修改项目信息</Button>
                    </Col>
                </Row>
                   <Row class="box-top-bottom">
                    <Col span="3"><img src="../../assets/name_icon.png" alt=""> <span>{{ProjectDetail.ContactName}}</span></Col>
                    <Col span="3"><img src="../../assets/mobile_icon.png" alt=""> <span>{{ProjectDetail.Tel}}</span></Col>
                    <Col span="3"><img src="../../assets/QQ_icon.png" alt=""> <span>{{ProjectDetail.QQ}}</span></Col>
                    <Col span="11"><img src="../../assets/email_icon.png" alt=""> <span>{{ProjectDetail.Email}}</span></Col>
                    <Col v-if="UserType == 2 || UserType == 3" span="4"><span >竞标数 {{BiddingList.length}} 人 </span></Col>
                </Row>
            </div>
            <div v-if="UserType!=1" class="btn-tips">
                <p @click="openInfo">查看全部信息<Icon type="ios-arrow-down" /></p>
            </div>
            <div v-if="showProjectDetail" class="box-center">
                <h2><img src="../../assets/user_icon.png"/>项目需求</h2>
                <p>{{ProjectDetail.Content}}</p>
            </div>
            <div v-if="showProjectDetail" class="box-center">
                <h2><img src="../../assets/link_icon.png"/>附件</h2>
                <ul>
                    <li v-for="(item,index) in ProjectDetail.Attach">
                       <a :href="fileUrl+item.url"><Icon type="md-attach" /><span>{{item.name}}</span></a>
                    </li>
                </ul>
            </div>
            <div v-if="UserType==1" class="box-center">
                <h2><img src="../../assets/my_icon.png"/>我的记录</h2>
                <Table :columns="columnsBiddingRecordList" :data="BiddingRecordList"></Table>
            </div>
        </div>
        <div v-if="UserType!=1" class="box-contaner">
            <Table class="table-BiddingList" :columns="columnsBiddingList" :data="BiddingList"></Table>
        </div>
        <Modal  v-model="showBiddingDetail" :closable="false" width='1050'>
           <div slot="header" class="header-modal">
               <img src="../../assets/detail.png" alt="">
               <span>竞价详情</span>
               <img class="close" @click="showBiddingDetail=false" src="../../assets/close.png" alt="">
           </div>
            <div class="content-modal table-c">
                <Tabs value="name1">
                    <TabPane label="基本信息" name="name1">
                        <table border="0" cellspacing="0" cellpadding="0">
                            <tr>
                                <td  class="label"  width="100">项目报价</td>
                                <td width="400">{{BiddingDetail.Apply_Fee}}元</td>
                                <td  class="label"  width="100">项目周期</td>
                                <td width="400">{{BiddingRecordDetail.Apply_Day}}天</td>
                            </tr>
                            <tr>
                                <td  class="label"  width="100">联系人</td>
                                <td width="400">{{BiddingDetail.Apply_ContactName}}</td>
                                <td  class="label"  width="100">手机号</td>
                                <td width="400">{{BiddingDetail.Apply_Tel}}</td>
                            </tr>
                            <tr>
                                <td class="label" width="100">邮箱</td>
                                <td width="400">{{BiddingDetail.Apply_Email}}</td>
                                <td  class="label"  width="100">提交时间</td>
                                <td width="400">{{BiddingDetail.AddTime}}</td>
                            </tr>
                            <tr>
                                <td class="label" width="100">竞标说明</td>
                                <td width="800" colspan="5">{{BiddingDetail.Apply_Content}}</td>
                            </tr>
                            <tr v-if="BiddingDetail.Apply_Attach">
                                <td class="label" width="100">附件</td>
                                <td width="800" colspan="5">
                                   <ul>
                                        <li v-for="(item,index) in BiddingDetail.Apply_Attach">
                                            <a :href="fileUrl+item.url"><Icon type="md-attach" /><span>{{item.name}}</span></a>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </table>
                    </TabPane>
                    <TabPane label="竞价记录" name="name2">
                        <Table :row-class-name="rowClassName"  :columns="columnsBiddingRecordList" :show-header="false" :data="MemberRecordList"></Table>
                    </TabPane>
                </Tabs>
            </div>
           <div slot="footer">
               <Button type="info" @click="showBiddingDetail=false" >关闭</Button>
           </div>
        </Modal>
        <Modal  v-model="showBiddingRecordDetail" :closable="false" width='550'>
            <div slot="header" class="header-modal">
               <img src="../../assets/detail.png" alt="">
               <span>竞价记录详情</span>
               <img class="close" @click="showBiddingRecordDetail=false" src="../../assets/close.png" alt="">
            </div>
            <div class="content-modal table-c">
                <table border="0" cellspacing="0" cellpadding="0">
                          <tr>
                                <td  class="label"  width="100">项目报价</td>
                                <td width="140">{{BiddingRecordDetail.Fee}}元</td>
                                 <td  class="label"  width="100">项目周期</td>
                                <td width="140">{{BiddingRecordDetail.Day}}天</td>
                          </tr>
                          <tr>
                                <td  class="label"  width="100">联系人</td>
                                <td width="140">{{BiddingRecordDetail.Realname}}</td>
                                 <td  class="label"  width="100">手机号</td>
                                <td width="140">{{BiddingRecordDetail.Tel}}</td>
                          </tr>
                          <tr>
                               <td class="label" width="100">邮箱</td>
                                <td width="140">{{BiddingRecordDetail.Email}}</td>
                                <td  class="label"  width="100">提交时间</td>
                                <td width="140">{{BiddingRecordDetail.AddTime}}</td>
                          </tr>
                          <tr>
                               <td class="label" width="100">竞标说明</td>
                               <td width="380" colspan="5">{{BiddingRecordDetail.Content}}</td>
                          </tr>
                    </table>
            </div>
           <div slot="footer">
               <Button type="info" @click="showBiddingRecordDetail=false" >关闭</Button>
           </div>
       </Modal>
       <Modal  v-model="showChooseProject" :closable="false" width='765'>
            <div slot="header" class="header-modal">
               <img src="../../assets/detail.png" alt="">
               <span>选为承接人</span>
               <img class="close" @click="showChooseProject=false" src="../../assets/close.png" alt="">
            </div>
            <div class="content-modal table-c">
                <Row class="chooseProjectRow">
                    <Col span="6">意向人：</Col>
                    <Col span="12" style="border-bottom:1px solid #01aae3;padding-bottom:5px">{{chooseProjectInfo.Apply_ContactName}}</Col>
                </Row>
                <Row class="chooseProjectRow">
                    <Col span="6">支付日期：</Col>
                    <Col span="12"><DatePicker v-model="chooseProjectValidate.EndTime" type="date" placeholder="" style="width: 300px"></DatePicker></Col>
                </Row>
                <Row class="chooseProjectRow">
                    <Col span="6">合同条款：</Col>
                    <Col span="12"><Input :rows="4" v-model="chooseProjectValidate.ContractTerms" show-word-limit type="textarea" placeholder="" style="width: 300px" /></Col>
                </Row>
                <Row class="chooseProjectRow">
                    <Col span="6">合同条款文件：</Col>
                    <Col span="12">
                        <Upload :action="uploadUrl" :on-success="successValid" :on-remove="deleValid" >
                            <Button type="primary" >点击上传</Button>
                        </Upload>
                    </Col>
                </Row>
                <Row class="chooseProjectRow">
                    <Col span="6">款项数：</Col>
                    <Col span="12"><Input v-model="chooseProjectValidate.Amount" placeholder="" type="number" style="width: 300px" /></Col>
                </Row>
            </div>
            <div slot="footer">
               <Button type="info" @click="showChooseProject=false" >取消</Button>
               <Button type="success" @click="handleSubmit()">确定</Button>
            </div>
       </Modal>
    </div>
</template>
<script>
export default {
    data(){
        return{
            ID:0,//项目ID
            uploadUrl:this.$base,//上传地址
            UserType: 1,//用户类型
            AdminInfo: [],//用户信息
            showProjectDetail: false,//是否显示项目详情
            showBiddingDetail: false,//是否显示竞价详情弹框
            showBiddingRecordDetail: false,//是否显示竞价记录详情弹框
            showChooseProject: false,//是否显示选择承接人弹框
            fileUrl:this.$baseImg,//文件地址
            biddingProjectTxt:'',//修改按钮文本
            ProjectDetail:{},//项目详情
            BiddingList:[],//项目竞价列表
            BiddingRecordList:[],//项目竞价记录列表
            chooseProjectInfo: [],//选择承接人信息
            chooseProjectValidate:{//选择承接人表单信息
                EndTime: '',
                ContractTerms: '',
                ContractTermsFiles: [],
                Amount:''
            },
            BiddingDetail:[],//竞价详情
            BiddingRecordDetail:[],//竞价记录详情
            columnsBiddingList: [
                    {
                        title: '最后提交时间',
                        key: 'AddTime',
                        align:'center'
                    },
                    {
                        title: '竞标人',
                        key: 'Apply_ContactName',
                         align:'center'
                    },
                     {
                        title: '联系方式',
                        key: 'Apply_Tel',
                         align:'center'
                    },
                      {
                        title: '项目周期',
                        key: 'Apply_Day',
                         align:'center'
                    },
                      {
                        title: '项目报价',
                        key: 'Apply_Fee',
                         align:'center'
                    },
                    {
                        title: '操作',
                        key: 'address',
                        align:'center',
                        render:(h,params)=>{
                             var text="修改";
                             if(params.row.Status==0){
                                 text="竞标";
                             }
                              return h('div',[
                                     h('Button',{
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                            },
                                            on:{
                                                "click":()=>{
                                                    this.catBiddingDetail(params.row);
                                                }
                                            }
                                },'查看详情'),
                                h('Button',{
                                    style:{
                                        "margin-left":"10px"
                                    },
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    on:{
                                        "click":()=>{
                                            this.chooseProject(params.row);
                                        }
                                    }
                                },'选为承接人')
                            ])
                         }
                    }
                ],
            columnsBiddingRecordList: [//竞价记录列表格式
                    {
                        title: '提交时间',
                        key: 'AddTime',
                        align:'center'
                    },
                    {
                        title: '竞标人',
                        key: 'Realname',
                         align:'center'
                    },
                     {
                        title: '联系方式',
                        key: 'Tel',
                         align:'center'
                    },
                      {
                        title: '项目周期',
                        key: 'Day',
                         align:'center'
                    },
                      {
                        title: '项目报价',
                        key: 'Fee',
                         align:'center'
                    },
                    {
                        title: '操作',
                        key: 'address',
                        align:'center',
                        render:(h,params)=>{
                             var text="修改";
                             if(params.row.Status==0){
                                 text="竞标";
                             }
                              return h('div',[
                                     h('Button',{
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                            },
                                            on:{
                                                "click":()=>{
                                                    this.catBiddingRecordDetail(params.row);
                                                }
                                            }
                                },'查看详情')
                            ])
                         }
                    }
                ],
            MemberRecordList: [],
        }
    },
    mounted(){
        this.ID = this.$route.query.ID;
        this.AdminInfo = JSON.parse(this.$getLS('AdminInfo'));
        this.UserType = this.AdminInfo.Type;
        this.init();
    },
    methods:{
        //提交选为承接人表单
        handleSubmit() {
            if (this.chooseProjectValidate.EndTime == '') {
                this.$Message.error('请选择支付日期');return;
            }
            if (this.chooseProjectValidate.ContractTerms == '' && this.chooseProjectValidate.ContractTermsFiles == '') {
                this.$Message.error('请填写合同条款或者上传合同条款文件');return;
            }
            if (this.chooseProjectValidate.Amount == '') {
                this.$Message.error('请填写款项数');return;
            }
            var params = {
                ProjectID: this.ID,
                MemberID: this.chooseProjectInfo.MemberID,
                EndTime:this.chooseProjectValidate.EndTime,
                ContractTerms:this.chooseProjectValidate.ContractTerms,
                ContractTermsFiles:this.chooseProjectValidate.ContractTermsFiles,
                Amount:this.chooseProjectValidate.Amount,
            }
            this.$post('api/manage.ProjectManage/chooseProject',params).then(res=>{
                if(res.code==1){
                    this.$Message.success(res.msg);
                    this.$router.push({path:'BiddingProject'});
                }else{
                    this.$Message.error(res.msg);
                }
            })
        },
        //删除附件成功回调函数
        deleValid(res){
            for (let i = 0; i < this.chooseProjectValidate.ContractTermsFiles.length; i++) {
                if (this.chooseProjectValidate.ContractTermsFiles[i].Path == res.Path) {
                    this.chooseProjectValidate.ContractTermsFiles.splice(i,1);
                    break;
                }
            }
        },
        //上传附件成功回调函数
        successValid(res, file){//附件上传成功
            if(res.code == 1){
                this.chooseProjectValidate.ContractTermsFiles.push({'name':file.name,'url':res.Path});
            }
        },
        //初始化数据
        init(){
            let params = {
                ID:this.ID
            }
            this.$post('api/manage.ProjectManage/getProjectDetail', params).then(res=>{
                if (res.code == 1) {
                    let ProjectDetail = res.data;
                    if (ProjectDetail.Status > 1) {
                        this.$router.push({path:'ProjectDetailBidding',query:{ID:ProjectDetail.ID}});
                    }
                    ProjectDetail.Attach = JSON.parse(ProjectDetail.Attach);
                    this.ProjectDetail = ProjectDetail;
                }
            })
            let adminInfo = JSON.parse(this.$getLS('AdminInfo'));
            let paramsList = {
                ProjectID: this.ID,
                MemberID: adminInfo.ID
            }
            if (this.UserType == 1) {
                this.$post('api/manage.ProjectManage/getBiddingProjectRecordList', paramsList).then(res=>{
                    if (res.code == 1) {
                        this.BiddingRecordList = res.data;
                        if (this.BiddingRecordList.length) {
                            this.biddingProjectTxt = '修改竞标信息';
                        } else {
                            this.biddingProjectTxt = '我要竞标';
                        }
                    }
                })
                this.showProjectDetail = true;
            } else {
                let paramsList = {
                    ProjectID: this.ID,
                }
                this.$post('api/manage.ProjectManage/getBiddingProjectList', paramsList).then(res=>{
                    if (res.code == 1) {
                        let BiddingList = res.data;
                        for (let i = 0; i< BiddingList.length; i++) {
                            BiddingList[i]['Apply_Attach'] = JSON.parse(BiddingList[i]['Apply_Attach']);
                        }
                        this.BiddingList = BiddingList;
                    }
                })
            }
        },
        //查看竞价详情
        catBiddingDetail(row) {
            this.showBiddingDetail = true;
            this.BiddingDetail = row;
            let params = {
                ProjectID: this.ID,
                MemberID: row.MemberID
            }
            this.$post('api/manage.ProjectManage/getBiddingProjectRecordList', params).then(res=>{
                if (res.code == 1) {
                    this.MemberRecordList = res.data;
                }
            })
        },
        //查看竞价记录详情
        catBiddingRecordDetail(row) {
            this.showBiddingRecordDetail = true;
            this.BiddingRecordDetail = row;
        },
        //编辑项目信息
        editProject() {
            this.$router.push({path:'PublishProject',query:{ID:this.ID}});
        },
        //编辑竞价信息
        editBiddingProject() {
            if (this.BiddingRecordList.length) {
                this.$router.push({path:'PublishBiddingProject', query:{ID:this.ID,Type:1}});
            } else {
                this.$router.push({path:'PublishBiddingProject', query:{ID:this.ID,Type:0}});
            }
        },
        //打开全部信息
        openInfo(){
           this.showProjectDetail=!this.showProjectDetail;
        },
        //选为承接人
        chooseProject(row) {
            this.chooseProjectInfo = row;
            this.showChooseProject = true;
            this.chooseProjectValidate = {
                EndTime: '',
                ContractTerms: '',
                ContractTermsFiles: [],
                Amount:''
            }
        },
        //列表样式名
        rowClassName (row, index) {
            if ((index%2) === 1) {
                return 'demo-table-info-row';
            } 
            return '';
        }
    }
    
}
</script>
<style lang="less" scoped >
.box{
    padding:30px;
    box-sizing: border-box;
            background-color: #F0F3F6;
    .box-contaner{
        background-color: #fff;
        margin-top: 20px;
        box-shadow: 3px 4px 5px #eee;
        .box-top{
            padding:20px;
            background-color: #F7FAFC;
            padding-bottom:0px;
            margin-bottom: 20px;
            .box-top-title{
                margin-bottom: 20px;
            }
                 .box-top-center{
            font-size: 14px;
            color:#9DA6AC;
            margin-bottom: 20px;
            .ivu-col-span-3{
                border-left:1px solid #D9D9D9;
                border-right:1px solid #D9D9D9;
                text-align: center;
            }
            span{
                color: #334659;
            }
        }
        .box-top-bottom{
            border-top:1px solid #E6E9EB;
            border-bottom:1px solid #E6E9EB;
            padding: 10px 0px;
            .ivu-col{
                display: flex;
                span{
                    color: #8795A4;
                    font-size: 14px;
                    margin-left: 10px;
                }
            }
        }
            .title{
                        font-size: 20px;
                        button{
                            margin-left: 10px;
                        }
                    }
        .ivu-col-span-4{
             text-align: right;
             display: block!important;
             span{
                 float: right;
                 color: #334659!important;
             }

        }
        }
        .btn-tips{
         text-align: center;
         font-size: 15px;
         padding-bottom: 10px;
         cursor: pointer;
     }
        .box-center{
            padding:20px;
            h2{
                display: flex;
                font-size: 22px;
                font-weight: normal;
                margin-bottom:20px;
                img{
                    margin-right:10px;
                }
            }
            >p{
                font-size: 16px;
                line-height: 30px;
            }
            >ul{
                overflow: hidden;
                li{
                    float: left;
                    margin-right: 10px;
                }
            }
        }
    }
}

.table-c{
 table{
     border-right:1px solid #CAF2FF;border-bottom:1px solid #CAF2FF;
  td{
border-left:1px solid #CAF2FF;
padding:10px;
  text-align: center;
  border-top:1px solid #CAF2FF;
  font-size:12px;}
  .label{
      background-color: #F0FCFF;
      color: #0092C1;
  }
 } 
}
.header-modal{
        padding:10px 15px;
        color: #fff;
        background-color: #01AAE3;
        font-size: 22px;
        display: flex;
        position: relative;
        span{
            margin-left: 20px;
            margin-top: 3px;
        }
        .close{
            width: 22px;
            height: 22px;
            position: absolute;
            right:14px;
            cursor: pointer;
            top:14px;
        }
    }
    .content-modal{
        padding:20px;
    }
    .table-BiddingList{
    margin-top: 20px;
    box-shadow: 0px 3px 5px #D9DDE3;
}
.chooseProjectRow {
    margin-left:18%;
    margin-bottom:30px;
}
</style>


// WEBPACK FOOTER //
// src/view/Project/BiddingProjectDetail.vue